import LoadingButton from './LoadingButton';
export * from './LoadingButton';

export default LoadingButton;
